import { render, staticRenderFns } from "./StatusListCategory.vue?vue&type=template&id=89d0b678&scoped=true&"
import script from "./StatusListCategory.vue?vue&type=script&lang=js&"
export * from "./StatusListCategory.vue?vue&type=script&lang=js&"
import style0 from "./StatusListCategory.vue?vue&type=style&index=0&id=89d0b678&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d0b678",
  null
  
)

export default component.exports